import React from "react";
import styled, { keyframes } from "styled-components";
import leanIcon from "../images/lean-icon@2x.png";

const spin = keyframes`
    from {
        transform: rotate(0deg);
    };
    to {
        transform: rotate(360deg);
    }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  margin-top: -60px;

  p {
    font-size: 14px;
    opacity: 0.5;
  }
`;

const Img = styled.img`
  width: 56px;
  height: 56px;
  animation: ${spin} 2s infinite;
`;

const Loading = () => (
  <Wrapper>
    <Img src={leanIcon} />
    <p>Connecting to Link</p>
  </Wrapper>
);

export default Loading;
